import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';
import { selectSizeB, selectSizeC, selectShowInvalids } from '@store/order/selectors';
import { setSizeB, setSizeC } from '@store/order/slice';
import catDimensionsFull from '@assets/images/order-cat-dimensions-full.svg';
import NumberField from '@components/text-field/NumberField';
import { invalidFormValue } from '@components/utils';



const DimensionsSection = () => {
	const { t } = useTranslation([ 'forms', 'links' ]);

	const sizeB = useSelector(selectSizeB);
	const sizeC = useSelector(selectSizeC);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateSizeB = (value: number | null) => dispatch(setSizeB(value));
	const updateSizeC = (value: number | null) => dispatch(setSizeC(value));

	return (
		<div className='dimensions-section'>
			
			<div className='dimensions-image'>
				<div className='dimensions-labels'>
					<p><span>A</span>{t('animalInfo.dimensions.imageCatA')}</p>
					<p><span>B</span>{t('animalInfo.dimensions.imageCatB')}</p>
				</div>
				<img src={catDimensionsFull} alt='animal-dimensions-image' />
			</div>
			
			<label className='dimensions-label'>
				{t('animalInfo.dimensions.sectionLabel') + ' '}<span>*</span>
			</label>
		
			<div className='dimensions-inputs'>
				
				<NumberField
					label='A'
					placeholder={t('units.dimensionUnit')}
					valueUnits={t('units.dimensionUnit')}
					rounded={true}
					value={sizeB}
					allowDecimal={false}
					maxNumber={1000}
					onChange={updateSizeB}
					errorMessage={showInvalids && invalidFormValue(sizeB) ? t('validation.requiredField') : undefined} />
				
				<NumberField
					label='B'
					placeholder={t('units.dimensionUnit')}
					valueUnits={t('units.dimensionUnit')}
					rounded={true}
					value={sizeC}
					allowDecimal={false}
					maxNumber={1000}
					onChange={updateSizeC}
					errorMessage={showInvalids && invalidFormValue(sizeC) ? t('validation.requiredField') : undefined} />
			</div>

			<p>{t('animalInfo.dimensions.warning')}</p>
		
			<p className='dimensions-link'>{t('animalInfo.dimensions.videoText') + ' '}
				<Link to={t('video.dimensionsHowTo', { ns: 'links' })} className='disable-selection' target='_blank'>
					{t('animalInfo.dimensions.videoLabel')}
				</Link>.
			</p>

		</div>
	);
};

export default memo(DimensionsSection);